import FormWizardOneContainer from "../../Componant/FormLayout/FormWizardOne";

const FormWizardOne = () => {
  return (
    <div className="page-body">
      <FormWizardOneContainer />
    </div>
  );
};

export default FormWizardOne;
